import { useHistory } from 'react-router-dom';
import { getColumns } from './schema';
import { getDefaultAction } from './schema';
import { TableCell } from './TableCell';
import { TableRow } from './TableRow';
import { React } from 'libs/react';
/**
 * @component TableContent
 * @since 1.0.0
 * @hidden
 */
export function TableContent(props) {
    const { schema, value, onRowClick } = Object.assign({}, props);
    const history = useHistory();
    /**
     * @function render
     * @since 1.0.0
     * @hidden
     */
    function render(column) {
        const renderer = schema[column];
        if (renderer) {
            return renderer.render(value);
        }
        return '';
    }
    /**
     * @function onClick
     * @since 1.0.0
     * @hidden
     */
    function onClick(e) {
        const defaultAction = getDefaultAction(schema, value);
        if (defaultAction) {
            history.push(defaultAction);
        }
        if (onRowClick) {
            onRowClick(value, e);
        }
    }
    const columns = getColumns(schema);
    return (React.createElement(TableRow, { onClick: onClick }, columns.map((column) => {
        var _a, _b;
        return (React.createElement(TableCell, { key: column, style: column, align: (_a = schema[column]) === null || _a === void 0 ? void 0 : _a.align, column: (_b = schema[column]) !== null && _b !== void 0 ? _b : undefined, onClick: () => { var _a, _b; return (_b = (_a = schema[column]) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 ? void 0 : _b.call(_a, value); } }, render(column)));
    })));
}
